import { render, staticRenderFns } from "./takeQuiz.vue?vue&type=template&id=0f4b6c99&scoped=true"
import script from "./takeQuiz.vue?vue&type=script&lang=js"
export * from "./takeQuiz.vue?vue&type=script&lang=js"
import style0 from "./takeQuiz.vue?vue&type=style&index=0&id=0f4b6c99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b6c99",
  null
  
)

export default component.exports